import React from 'react';
import { useEmployeeEngagementDashboardStore } from 'pages/ReportsPage/components/AnalyticsDashboards/EmployeeEngagementDashboard/store/employeeEngagement.store';
import { useChartColors } from 'pages/ReportsPage/components/AnalyticsDashboards/chartColors';
import {
  HorizontalBarChart,
  HorizontalBarItem,
} from 'pages/ReportsPage/components/AnalyticsDashboards/OverviewDashboard/HorizontalBarChart';
import { EmptyStateContainer } from 'pages/ReportsPage/components/AnalyticsDashboards/EmployeeEngagementDashboard/EmployeeEngagementDashboard.styled';
import { formatDashboardNumber } from 'pages/ReportsPage/components/AnalyticsDashboards/formatDashboardNumber';

export const CancellationByPositionChart: React.FC = () => {
  const data = useEmployeeEngagementDashboardStore((s) => s.cancellationByPosition);
  const hasError = useEmployeeEngagementDashboardStore((s) => s.cancellationByPositionError);
  const page = useEmployeeEngagementDashboardStore((s) => s.cancellationByPositionPage);
  const totalPages = useEmployeeEngagementDashboardStore((s) => s.cancellationByPositionTotalPages);
  const loadingMore = useEmployeeEngagementDashboardStore(
    (s) => s.cancellationByPositionLoadingMore,
  );
  const loadMore = useEmployeeEngagementDashboardStore((s) => s.loadMoreCancellationByPosition);
  const palette = useChartColors();

  if (hasError) {
    return <EmptyStateContainer>Failed to load cancellation by position data</EmptyStateContainer>;
  }

  if (!data || data.length === 0) {
    return (
      <EmptyStateContainer>
        No cancellation data available for the selected filters.
      </EmptyStateContainer>
    );
  }

  const barColor = palette.chartColors[0];

  const items: HorizontalBarItem[] = data.map((d) => {
    const percentage = formatDashboardNumber(d.cancelledPrct);
    return {
      label: d.position,
      value: d.cancelledPrct,
      valueLabel: `${percentage}%`,
      ariaLabel: `${d.position}: ${percentage}% post-accept cancellation rate`,
      tooltipHtml: `<strong>${d.position}</strong><br/>Cancellation rate: ${percentage}%<br/>Cancelled: ${d.cancelledShiftCount} of ${d.totalShiftCount}`,
      barColor,
    };
  });

  return (
    <HorizontalBarChart
      items={items}
      maxValue={100}
      leftMargin={220}
      rightMargin={70}
      wrapLabels
      scrollable
      ariaLabel="Cancellation by position chart showing post-accept cancellation rate per position"
      onLoadMore={loadMore}
      hasMore={page < totalPages}
      isLoadingMore={loadingMore}
    />
  );
};
